<template>
  <v-main>
    <v-container>
      <div class="text-2xl mb-5">{{ t("supervisorOrgSettings.title") }}</div>
      <v-tabs color="primary" class="mb-5">
        <v-tab :to="{ name: 'SupervisorOrgGeneralSettings' }">{{
          t("supervisorOrgSettings.tabs.account")
        }}</v-tab>
        <v-tab :to="{ name: 'SupervisorOrgUsers' }">{{
          t("supervisorOrgSettings.tabs.users")
        }}</v-tab>
        <v-tab
          v-if="user.hasRole(apiKeyManagerRoles, 'supervisorOrg')"
          :to="{ name: 'SupervisorOrgApiSettings' }"
          >{{ t("supervisorOrgSettings.tabs.api") }}</v-tab
        >
        <v-tab v-if="user.isKind('admin')" :to="{ name: 'SupervisorOrgAdmin' }">{{
          t("supervisorOrgSettings.tabs.admin")
        }}</v-tab>
      </v-tabs>
      <router-view></router-view>
    </v-container>
  </v-main>
</template>

<script setup lang="ts">
import { useI18n } from "@/composables/useI18n";
import { useUserStore } from "@/store/user";
import { apiKeyManagerRoles } from "@aircap/common/auth";

const { t } = useI18n();
const user = useUserStore();
</script>
